import slugify from './slugify'
import {Router} from 'next/router'
import {useEffect} from 'react'

export const getCatalogedBrandUrl = function (brand: Brand): string {
  return `/brands/${slugify(brand.name ?? '')}-${brand.catalogGroupId}`
}

export const getFacetedBrandUrl = function (brand: Brand): string {
  const trimmedId = `${brand.facetId}`.substr(0, 6)
  return `/f/${slugify(brand.name ?? '')}_f1v${trimmedId}`
}

export const getJsonFileFromQuery = (inputString: string, isNma: boolean) => {
  const matchedString = inputString.match(/\/_next\/data\/([^/]+)\/([^/.]+)\.json\?index=([^&]+)(?:&cgId=([^/]+))?/)
  if (matchedString) {
    const slug = matchedString[1]
    const cgId = matchedString[4]
    if (isNma) {
      return cgId ? `/_next/data/${slug}/cgId-${cgId}/nma.json` : `/_next/data/${slug}/brands/nma.json`
    }
    return cgId ? `/_next/data/${slug}/cgId-${cgId}.json` : `/_next/data/${slug}/brands.json`
  }

  return inputString
}

export const useFormatCacheUrl = ({nextRouter, namespace, isNma}: { nextRouter: Router, namespace: string, isNma: boolean}) => {
  useEffect(() => {
    if (nextRouter.pageLoader?.getDataHref) {
      const originalCacheUrl = nextRouter.pageLoader.getDataHref
      nextRouter.pageLoader.getDataHref = function (queryParams: { asPath: string, href: string, locale: string | false, skipInterpolation: boolean }) {
        const router = originalCacheUrl.call(nextRouter.pageLoader, queryParams)

        return router && router.startsWith('/_next/data')
          ? `/${namespace}${getJsonFileFromQuery(router, isNma)}`
          : router
      }
    }
  }, [nextRouter, namespace])
}
